import React from 'react';
import { SharedNavbar } from '../components/SharedNavbar';
import { Hero } from '../components/Hero';
import { ProblemSolution } from '../components/ProblemSolution';
import { ProgramPhases } from '../components/ProgramPhases';
import { Benefits } from '../components/Benefits';
import { AboutMe } from '../components/AboutMe';
import { ForWhom } from '../components/ForWhom';
import { Pricing } from '../components/Pricing';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function AnimaRecodePage() {
  return <>
      <SharedNavbar data-id="element-883" />
      <main className="flex-grow" data-id="element-884">
        <Hero data-id="element-885" />
        <ProblemSolution data-id="element-886" />
        <ProgramPhases data-id="element-887" />
        <Benefits data-id="element-888" />
        <AboutMe data-id="element-889" />
        <ForWhom data-id="element-890" />
        <Pricing data-id="element-891" />
        <FAQ data-id="element-892" />
        <FinalCTA data-id="element-893" />
      </main>
      <Footer data-id="element-894" />
    </>;
}